var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:{ 'cursor-pointer': !_vm.disabled && !_vm.readonly, disabled: _vm.disabled }},[_c('input',{attrs:{"disabled":_vm.disabled,"id":_vm.id,"type":_vm.type,"name":_vm.name,"hidden":""},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"input":_vm.input}}),_c('div',{staticClass:"check-box",class:[
            _vm.size == 'lg' ? 'big' : _vm.size == 'md' ? 'medium' : 'sm',
            _vm.theme == 'dark'
                ? 'dark'
                : _vm.theme == 'red'
                ? 'red'
                : _vm.theme == 'grey'
                ? 'grey'
                : _vm.theme == 'green'
                ? 'green'
                : 'light'
        ],style:([_vm.square ? { 'border-radius': '4px' } : {}]),attrs:{"for":"active"}},[_c('div',{staticClass:"checkmark pointer-events-none"})]),(_vm.showContent)?_c('span',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }